import {
  observable,
  transaction,
  map,
  computed,
  when,
  reaction,
  runInAction,
  action
} from 'mobx';
import {tools} from 'tplus-voucher';
import LoginApi from '../api/LoginApi';

const accountInfos = ['CanModifyCustomer','DetaileMerge',
                      'IsCurrentOperator','IsShowSaleDeliveryTotalQuantity',
                      'IsShowSaleOrderTotalQuantity','ARAPProjectManagement',
                      'IsControlQuantityValidDecimal','IsControlPriceValidDecimal',
                      'IsPriceReportingWithTax','PricePrecision',
                      'ProportionRatePrecision','QuantityPrecision',
                      'DiscountRateDecimalDigits','ReCreateBarCode','BatchNumberAutoBuildForReturn'
                      ,'MBAutoSettle','MBAutoPromotion','IsSAInventoryAutoDragInProjectInfo'];
export default class SysInfo {

  static async setSysInfo(){
    const sysInfo = await LoginApi.getSysInfoForGZQ();
    tools.setLocalCache('SysInfo',sysInfo);
  }

  static async setAccountInfos(){
    const param = {};
    param.infoNames = accountInfos;
    const accountInfo = await LoginApi.getAccountInfo(param);
      if(accountInfo){
        accountInfos.forEach(fieldName=>{
            if(!tools.isEmpty(accountInfo[fieldName])){
              tools.setLocalCache(fieldName,accountInfo[fieldName]);
            }
        });
      }
  }

  //设置T+下单相关的权限信息
  static async setOrderFunction(){
    try{
      let resp = await LoginApi.getOrderFunction({'appid':'1155'});
      if(resp.Funcs){
          tools.setLocalCache('orderFuncs',resp.Funcs);
      }
    }catch(err){
      tools.setLocalCache('orderFuncs','');
    }

  }

  static async setVoucherWorkFlow(){
    try{
      const param = {bizCodes:['SA03','SA04']}
      let resp = await LoginApi.getVoucherWorkFlow(param);
      if(resp){
          tools.setLocalCache('VoucherWorkFlow',resp);
      }
    }catch(err){
      tools.setLocalCache('VoucherWorkFlow','');
    }
  }

  //从缓存中恢复Channel对象
  static getSysInfo(){
    let SysInfoCache = tools.getLocalCache('SysInfo');
    if(!tools.isNull(SysInfoCache)){
      return SysInfoCache;
    }
    return undefined;
  }

  //获取T+下单相关的权限信息
  static getOrderFunction(){
    let funcs = tools.getLocalCache('orderFuncs');
    if(!tools.isNull(funcs)){
        return funcs.split(',');;
    }
    return undefined;
  }
  static async GetWhetherEnableSaleSingleFullGift(){
    const resp = await LoginApi.GetWhetherEnableSaleSingleFullGift();
    tools.setLocalCache('isEnablePromotion',resp);
  }
  
  static async getSaleDeliveryInvoiceType(){
    const resp = await LoginApi.getSaleDeliveryInvoiceType();
    tools.setLocalCache('saleDeliveryInvoiceType',resp.Items);
  }

  static async GetSignInOption(){
    const resp = await LoginApi.GetSignInOption();
    tools.setLocalCache('SignInOption',resp);
  }
  
}
